import { ListOfPropertiesValues } from "./ListOfPropertiesValues";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { UserService } from "@/modules/User/services/UserService";
import { Http } from "@status/codes";
import { AxiosError } from "axios";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES
} from "@/shared/constants/FormConstants";
import { USER_ACCESS } from "@/modules/User/constants/UserConstants";
import { UserTemplateService } from "@/modules/UserTemplate/services/UserTemplateService";
import { USER_TEMPLATES_ACCESS } from "@/modules/UserTemplate/constants/UserTemplateConstants";
import { RolesService } from "@/modules/Roles/services/RolesService";
import { ROLES_ACCESS } from "@/modules/Roles/constants/RoleConstants";
import { GENERAL_RULES_CONSTANTS } from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import { QuerySendMultiple } from "@/shared/models/FormQuerySend";
import { DependenciesService } from "@/modules/Dependencies/services/DependenciesService";
import { LACK_OF_OPTIONS } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { DEPENDENCIES_ACCESS } from "@/modules/Dependencies/constants/DependenciesConstants";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { InfoGroupService } from "@/modules/InfoGroup/services/InfoGroupService";
import { UserQuery } from "@/modules/User/models/UserQuery";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { FIELD_WITHOUT_DATA } from "@/modules/DashboardTemplate/constants/DashboardTemplatesConstants";

export class UsersPropertiesValues extends ListOfPropertiesValues {
  user = this.getUsers;
  visualName = this.findUsers;
  createdBy = this.getUsers;
  changedBy = this.getUsers;
  userTemplateId = this.getUserTemplates;
  roleId = this.getRoleList;
  dependencyId = this.getDependenciesList;
  infoGroupId = this.getExtraInfoGroups;

  keyword = "";
  lastRef = "";
  lasRefWithNameFilter = "";
  indexSectionOfDashboard = 0;
  indexCollection = 0;
  lastDocId = "";

  async loadItems(
    field: string,
    idList?: string,
    keyWord?: string,
    lastDocId?: string
  ) {
    this.lastDocId = lastDocId || "";
    console.log("field", field);
    if (keyWord) {
      return (await this[field as keyof UsersPropertiesValues](
        keyWord
      )) as DynamicSelectData[];
    }

    if (this.keyword) {
      this.keyword = "";
      this.lastRef = "";
    }

    if (idList) {
      return this.getList(idList);
    }

    return await this[field as keyof UsersPropertiesValues]();
  }

  async getUsers(name?: string) {
    return await this.getUserByQuery(this.setFilters.bind(this), name);
  }

  async getUserTemplates() {
    try {
      const userTemplateService = new UserTemplateService();
      const response = await userTemplateService.getAllActiveUserTemplates();
      if (response.code === Http.Found && response.data) {
        const formTemplatesUser = response.data;
        const formTemplatesUserList: DynamicSelectData[] = [];
        formTemplatesUser.forEach(({ _key, name }) => {
          formTemplatesUserList.push({ id: _key, name });
        });
        formTemplatesUserList.push(FIELD_WITHOUT_DATA);
        return { data: formTemplatesUserList };
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        return Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + USER_TEMPLATES_ACCESS.GET
        );
      else return Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getRoleList() {
    try {
      const rolesService = new RolesService();
      const response = await rolesService.getAllActiveRoles();

      if (response.code === Http.Found && response.data) {
        const rolesUser = response.data;
        const rolesUserList: DynamicSelectData[] = [];
        rolesUser.forEach(({ id, name }) => {
          rolesUserList.push({ id: id, name });
        });
        rolesUserList.push(FIELD_WITHOUT_DATA);
        return { data: rolesUserList };
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        return Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + ROLES_ACCESS.GET
        );
      else return Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getDependenciesList() {
    try {
      const filter: QuerySendMultiple = {
        state: [GENERAL_RULES_CONSTANTS.ACTIVO]
      };

      if (this.lastDocId) {
        filter.docref = this.lastDocId;
        filter.paginatedResult = true;
      }
      console.log("filter", filter);

      const dependenciesService = new DependenciesService();
      const responseData = await dependenciesService.getDependenciesWithFilters(
        filter
      );
      if (responseData.code === Http.Found && responseData.data) {
        const depenednciesList: DynamicSelectData[] = [];
        const dataList = responseData.data.data;
        dataList.forEach(dependency =>
          depenednciesList.push({ id: dependency.id!, name: dependency.name })
        );
        depenednciesList.push(FIELD_WITHOUT_DATA);
        return { data: depenednciesList, lastDocId: responseData.data.docRef };
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      console.log(error);

      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DEPENDENCIES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getExtraInfoGroups() {
    try {
      const infoGroupService = new InfoGroupService();
      const response = await infoGroupService.getInfoGroupByFilters({
        state: FORM_CONSTANTS.STATE.ACTIVE
      });

      if (response.code === Http.Found && response.data) {
        const formTemplatesUser = response.data.groups;
        const formTemplatesUserList: DynamicSelectData[] = [];
        formTemplatesUser.forEach(({ _key, name }) => {
          formTemplatesUserList.push({ id: _key, name });
        });
        formTemplatesUserList.push(FIELD_WITHOUT_DATA);
        return { data: formTemplatesUserList };
      }

      Snackbar.popInfo(response.message);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DEPENDENCIES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async findUsers(name?: string) {
    try {
      if (!name) return [];

      const filterQuery = this.setFilters(
        GENERAL_RULES_CONSTANTS.ID_REFERENCE,
        name
      );

      const userService = new UserService();
      const responseUsers = await userService.getUserByFilters(
        filterQuery as UserQuery
      );

      if (responseUsers.code === Http.Found) {
        this.lastRef = responseUsers.data?.lastReference!;
        const userList: DynamicSelectData[] = [];
        responseUsers.data?.userArray.forEach(user => {
          userList.push({
            id: user.name!,
            name: user.name!
          });
        });
        userList.push(FIELD_WITHOUT_DATA);
        return {
          data: responseUsers.data?.userArray.map(user => ({
            id: user.name,
            name: user.name
          }))
        };
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  setFilters(keyLastRef: string, name?: string) {
    const filterQuery: any = {
      state: GENERAL_RULES_CONSTANTS.ACTIVO
    };

    if (name && this.keyword !== name) {
      this.keyword = name;
      filterQuery.name = name;
      delete filterQuery[keyLastRef];
      return filterQuery;
    }

    if (name) {
      filterQuery.name = name;
      if (this.keyword !== name) {
        this.keyword = name;
      }
      return filterQuery;
    }

    return filterQuery;
  }

  setIndexes(
    indexSectionOfDashboard: number,
    indexCollectionFilter: number
  ): void {
    this.indexSectionOfDashboard = indexSectionOfDashboard;
    this.indexCollection = indexCollectionFilter;
  }
}
